import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import recordDescriptorProcessing  from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';

let helpers = {
  getReferenceDocuments: (
    searchString,
    document_type = '',
    markets = '',
    dateRange = {},
    sortField = '',
    ascending,
    page,
    perPage
  ) => {

    let url =
      process.env.REACT_APP_API +
      '/reference_documents?current_company=' +
      localStorage.current_company_id +
      '&keywords=' +
      (searchString ? searchString : '') +
      '&document_type=' +
      (document_type ? document_type : '') +
      '&market=' +
      (markets ? markets : '');

    let sDate = new Date(dateRange.start_date).toUTCString();
    let eDate = new Date(dateRange.end_date).toUTCString();

    let utcStart = Date.parse(sDate);
    let utcEnd = Date.parse(eDate);
    utcEnd += 24 * 60 * 60 * 1000 -1;

    let offset = (new Date().getTimezoneOffset() * 60 * 1000);

    utcStart += offset;
    utcEnd += offset;
    
    url += dateRange.start_date ? `&start_date=${Math.floor(utcStart / 1000)}` : '';
    url += dateRange.end_date ? `&end_date=${Math.floor(utcEnd / 1000)}` : '';
      
    if (sortField) {
      url += '&order=' + sortField + (ascending ? ',asc' : ',desc');
    }
    if (page) {
      url += '&page=' + page + '&per=' + (perPage ? perPage : 7);
    }

    return axios({
      method: 'get',
      url: url,
      headers: {
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getReferenceDocumentsByGroup: (group_identifier, options) => {
    let url = process.env.REACT_APP_API +
      '/reference_documents/show_group?current_company=' +
      localStorage.current_company_id +
      '&group_identifier=' +
      group_identifier;
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
  
    return axios({
      method: 'get',
      url: url,
      headers: {
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        if (options) {
          return response.data;
        }
        else {
          return response.data.reference_documents;
        }
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getReferenceDocument: (reference_document_id, options) => {
    let url = process.env.REACT_APP_API +
    '/reference_documents/' +
    reference_document_id +
    '?current_company=' +
      localStorage.current_company_id;
    
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: url,
      timeout: 20000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  checkName: name => {
    return axios({
      method: 'get',
      url:
        process.env.REACT_APP_API +
        '/reference_documents/check_name/' +
        '?current_company=' +
        localStorage.current_company_id +
        '&name=' + name,
      timeout: 20000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.reference_document;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createReferenceDocument: (reference_document, eventMetadatum) => {
    let data = new FormData();
    data.append('name', reference_document.name);
    data.append('attachment', reference_document.upload ? reference_document.upload : reference_document.attachment);
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    data.append('event_metadatum', JSON.stringify(eventMetadatum));
    return axios({
      method: 'post',
      url:
        process.env.REACT_APP_API +
        '/reference_documents?current_company=' +
        localStorage.current_company_id,
      data: data,
      timeout: 60000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  updateReferenceDocument: (reference_document, eventMetadatum) => {
    let data = new FormData();
    data.append('name', reference_document.name);
    data.append('attachment', reference_document.upload);
    data.append('group_identifier', reference_document.group_identifier);
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    data.append('event_metadatum', JSON.stringify(eventMetadatum));
    
    return axios({
      method: 'post',
      url:
        process.env.REACT_APP_API +
        '/reference_documents?current_company=' +
        localStorage.current_company_id,
      data: data,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteReferenceDocument: (reference_document_id, eventMetadatum) => {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url:
        process.env.REACT_APP_API +
        '/reference_documents/' +
        reference_document_id +
        '?current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      data: {
        eventMetadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  checkFileIsInUse: (id) => {
    return axios({
      method: 'get',
      url: 
        `${process.env.REACT_APP_API}/reference_documents/${id}/check_group_identifier` +
        `?current_company=${localStorage.current_company_id}`,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  fetchBase64: (url, taskPage = {}) => {
    return axios({
      method: 'post',
      url:
        process.env.REACT_APP_API +
        '/pdf-encoder?current_company=' +
        localStorage.current_company_id,
      data: {
        imageUrl: url,
        taskPage: taskPage,
      },
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/referenceDocumentsServices.js